import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Row } from 'react-bootstrap';
import { useTheme } from './useTheme';

// Paper: plain "← back to contents" link. Other themes: the original button.
const BackHome = ({ variant }) =>
  useTheme() === 'paper' ? (
    <footer className="paper-post-foot"><Link to="/">← back to contents</Link></footer>
  ) : (
    <Row className="pt-5 pb-5 mt-5 mb-5">
      <Link to="/"><Button style={{ fontSize: '1rem' }} variant={variant} type="submit">Back Home</Button></Link>
    </Row>
  );

export default BackHome;
